module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page wallet"
  }, [_c('pageTitle', {
    attrs: {
      "title": "充值"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mes"
  }, [_c('p', [_vm._v("订单号：" + _vm._s(_vm.g_rechargeMsg.id))]), _vm._v(" "), _c('p', [_vm._v("￥\n            "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.g_rechargeMsg.money))])]), _vm._v(" "), _c('p', [_vm._v("备注：储值卡充值")])]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('mu-list', [_c('mu-sub-header', {
    staticStyle: {
      "font-size": "0.3rem",
      "color": "#666666"
    }
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "银联支付"
    },
    on: {
      "click": function($event) {
        return _vm.goPay(1)
      }
    }
  }, [_c('mu-avatar', {
    attrs: {
      "slot": "leftAvatar",
      "src": "../../../static/wallet/unionPay.png",
      "backgroundColor": "transparent"
    },
    slot: "leftAvatar"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list-item', {
    style: ({
      display: _vm.allowAlipay
    }),
    attrs: {
      "title": "支付宝支付"
    },
    on: {
      "click": function($event) {
        return _vm.goPay(3)
      }
    }
  }, [_c('mu-avatar', {
    attrs: {
      "slot": "leftAvatar",
      "src": "../../../static/wallet/aliPay.png",
      "backgroundColor": "transparent"
    },
    slot: "leftAvatar"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mu-divider', {
    style: ({
      display: _vm.allowAlipay
    })
  }), _vm._v(" "), _c('mu-list-item', {
    style: ({
      display: _vm.allowWepay
    }),
    attrs: {
      "title": "微信支付"
    },
    on: {
      "click": function($event) {
        return _vm.goPay(6)
      }
    }
  }, [_c('mu-avatar', {
    attrs: {
      "slot": "leftAvatar",
      "src": "../../../static/order/wepay.png",
      "backgroundColor": "transparent"
    },
    slot: "leftAvatar"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mu-divider', {
    style: ({
      display: _vm.allowWepay
    })
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c00bb3c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wallet/recharge/payStyle.vue
// module id = 1587
// module chunks = 18